import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";
import { publicApi, errMsg } from "@/lib/api";

const input = "mt-1 w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]";

export function EnquiryForm({ type, fields, cta, testPrefix }) {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await publicApi.post("/enquiries", { type, ...form });
      setDone(true);
      toast.success("Thanks! Our team will call you within 24 hours.");
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  if (done) return (
    <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-8 text-center" data-testid={`${testPrefix}-success`}>
      <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-500" />
      <p className="mt-4 text-lg font-semibold">Request received</p>
      <p className="mt-1 text-sm text-neutral-600">Our team will contact you within 24 hours.</p>
    </div>
  );
  return (
    <form onSubmit={submit} className="space-y-4 rounded-3xl border border-black/5 bg-white p-6 shadow-xl shadow-black/5 sm:p-8" data-testid={`${testPrefix}-form`}>
      {fields.map((f) => (
        <label key={f.key} className="block text-sm font-medium">{f.label}
          {f.textarea
            ? <textarea rows={3} required={f.required} value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`${testPrefix}-${f.key}`} placeholder={f.placeholder} className={input} />
            : <input required={f.required} type={f.type || "text"} inputMode={f.key === "phone" ? "numeric" : undefined} value={form[f.key] || ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`${testPrefix}-${f.key}`} placeholder={f.placeholder} className={input} />}
        </label>
      ))}
      <button type="submit" disabled={busy} data-testid={`${testPrefix}-submit`} className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#FF5A00] py-3.5 font-semibold text-white transition-colors duration-200 hover:bg-[#e65100] disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />}{cta}
      </button>
    </form>
  );
}
